export class SmartBagComboMasterModel {
    public  ComboMasterID:number;
    public  ComboMasterName:string;
    public  ComboCommand:string;
    public  UserID:number;

    public ComboMasterAutoComplete:any;
    public ComboMasterlist:SmartBagComboMasterModel[];
}
